//返回性别
export function sexDate(){
    let sex = [
        {id:1, sex:'男', value:1,},
        {id:2, sex:'女', value:2,},
        {id:3, sex:'未知',value:0,}
        ]
    return sex
}
//返回学历
export function educationList(){
    let education = [
            {
                id:'1',
                education:'初中'
            },
            {
                id:'2',
                education:'高中'
            },
            {
                id:'3',
                education:'专科'
            },
            {
                id:'4',
                education:'本科'
            },
            {
                id:'5',
                education:'研究生'
            },
        ]
    return education
}
